import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { PUBLISH_SING_PRODUCT_PATH_A } from '@constant'
import styles from './style.module.less'

export default class extends Component {
  render() {
    return (
      <HeaderView title="发布单品">
        <p className={styles.title}>请选择单品类型</p>
        <ul className={styles.imageWrap}>
          <li>
            <a href={`${PUBLISH_SING_PRODUCT_PATH_A}?isSingle=1&gender=0`}>
              <img src="//qnm.hunliji.com/o_1cvi7n7jlq4013c01s0v1chl1phfb.png" />
              <p>女士单品</p>
            </a>
          </li>
          <li>
            <a href={`${PUBLISH_SING_PRODUCT_PATH_A}?isSingle=1&gender=1`}>
              <img src="//qnm.hunliji.com/o_1cvi7n7jl1i5u66einaokt1gt9a.png" />
              <p>男士单品</p>
            </a>
          </li>
        </ul>
      </HeaderView>
    )
  }
}
